import React from 'react';
import './Modal.scss';

function NewMessage() {
  return (
    <div className="modal row align-center">
      <div className="column small-12 medium-10 large-6">
        <p>Для записи в Автошколу, или если у вас есть какие-либо вопросы,
          обращайтесь по телефонам:</p>
        <ul>
          <li>
            <a
              className="link"
              href="tel:+79519384029"
            >
              +7 (951) 938-40-29
            </a>
          </li>
        </ul>
          <p>
            Или пишите на электронную почту:
          </p>
          <span className="important">
            <a
              href="mailto:dieselperm@gmail.com?subject=Автошкола"
              className="link"
            >
              dieselperm@gmail.com
            </a>
          </span>
      </div>
    </div>
  );
}


export default NewMessage;



// WEBPACK FOOTER //
// ./src/components/Common/Modal/NewMessage.jsx